import * as fromUI from '../actions/ui.action';

export interface ViewerState {
  route: any;
  info: string;
}

export const initialState: ViewerState = {
  route: {} as any,
  info: 'This ui data is stored in the component.store class (core/store-component/)',
};

export function reducer(state = initialState, action: fromUI.UIActions): ViewerState {
  switch (action.type) {
    case fromUI.UPDATE_UI: {
      const route = action.payload;

      return {
        ...state,
        route,
      };
    }
  }
  return state;
}

export const getState = (state: ViewerState) => state.route;
